import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { EducationDetails } from '../model/EducationDetails';
import { QualificationType } from '../model/QualificationType';
import { TechnicianService } from '../service/technician.service';

@Component({
    selector: 'app-application-education-details',
    templateUrl: './application-education-details.component.html',
    styleUrls: ['./application-education-details.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ApplicationEducationDetailsComponent implements OnInit {
  @Input() educationDetails!: EducationDetails;
  courseTypes: Partial<Record<QualificationType, unknown[]>> = {};

  constructor(private service: TechnicianService) { }

  ngOnInit() {
    this.loadQualifications();
  }

  loadQualifications () {
    if(this.educationDetails.combined === null) {
      this.service.getQualificationList(QualificationType.knowledge).subscribe(qualifications => this.courseTypes[QualificationType.knowledge] = qualifications);
      this.service.getQualificationList(QualificationType.competency).subscribe(qualifications => this.courseTypes[QualificationType.competency] = qualifications);
    } else {
      this.service.getQualificationList(QualificationType.combined).subscribe(qualifications => this.courseTypes[QualificationType.combined] = qualifications);
    }       
  }

  getCourseTypes(type: string | number): unknown[] | null {
    const qualificationType = typeof type === 'number'
      ? type as QualificationType
      : QualificationType[type as keyof typeof QualificationType];
    return this.courseTypes[qualificationType] ?? null;
  }

}
